<template>
  <div class="container">
    <container :active_path="'/applet/advertising'"
               :plate="'真会投资'">
      <el-tabs v-model="activeName"
               tab-position="left"
               @tab-click="changetabs">
        <el-tab-pane label="开屏弹窗"
                     name="homepopup"
                     v-if="isAllCity">
          <div class="item-warp">
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">开屏弹窗</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in homepopup"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="dragend('homepopup')"
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        homepopup.previews
                                                    "></el-image>
                        <!-- <div class="cover-view">
                                                    <i class="el-icon-plus"></i>
                                                </div> -->
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'homepopup'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'homepopup',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'homepopup' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为363px*535px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('homepopup')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/52c2b8a09fb3d75fb883d7b0978adea.jpg"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="首页"
                     name="home">
          <div class="item-warp">
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">首页顶部banner</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in homebanners"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="
                                                    dragend('homebanners')
                                                "
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        homebanners.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'homebanners'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'homebanners',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'homebanners' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*540px的图片
                  </p>
                  <span v-if="isAllCity">城市：</span>
                  <el-select v-model="selectedCity"
                             v-if="isAllCity"
                             placeholder="请选择"
                             @change="handleCity"
                             class="selector">
                    <el-option v-for="item in cityList"
                               :key="item._id.$oid"
                               :label="item.label"
                               :value="item.label">
                    </el-option>
                  </el-select>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/a45a3d598f3f3148a4057cf073cec42.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>

            <el-row class="item-cell"
                    v-if="isAllCity">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">首页区域上方广告图</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in areatops"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="dragend('tutortops')"
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        areatops.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'areatops'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'areatops',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'homebanners' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*216px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('areatops')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/69bd470c5aef4184b2478564c989db5.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>

            <el-row class="item-cell"
                    v-if="isAllCity">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">首页导师上方广告图</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in tutortops"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="dragend('tutortops')"
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        tutortops.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'tutortops'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'tutortops',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'tutortops' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*216px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('tutortops')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/09ca59e44c65e8d00cef0ab9de100a0.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="投资资讯"
                     name="article"
                     v-if="isAllCity">
          <div class="item-warp">
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">投资资讯顶部banner</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in articlebanners"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="
                                                    dragend('articlebanners')
                                                "
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        articlebanners.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'articlebanners'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'articlebanners',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'articlebanners' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*540px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('articlebanners')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/788fecc2027b5eb0b86ab126bf3aee3.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">
                    投资资讯列表穿插广告
                  </p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in articlecells"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="
                                                    dragend('articlecells')
                                                "
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        articlecells.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'articlecells'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'articlecells',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'articlecells' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*216px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('articlecells')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/13c91b308685117c8e749ef67182358.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">
                    投资资讯详情页顶部广告图
                  </p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in articletops"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="
                                                    dragend('articletops')
                                                "
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        articletops.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'articletops'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'articletops',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'articletops' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*540px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('articletops')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/7ded66fbc464bdebcde002b2864ebea.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">
                    投资资讯详情页底部广告图
                  </p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in articlebottoms"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="
                                                    dragend('articlebottoms')
                                                "
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        articlebottoms.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'articlebottoms'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'articlebottoms',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'articlebottoms' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*216px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('articlebottoms')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/dad824376e7db2a120d6117be30dd8f.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="楼盘"
                     name="house"
                     v-if="isAllCity">
          <div class="item-warp">
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">楼盘列表页穿插广告</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in housecells"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="dragend('housecells')"
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        housecells.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'housecells'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'housecells',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'housecells' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*216px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('housecells')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/d71539525ae1cf9142a0fd0544dbd40.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">线上售楼部焦点图</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in housebanners"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="
                                                    dragend('housebanners')
                                                "
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        housebanners.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'housebanners'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'housebanners',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'housebanners' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*540px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('housebanners')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/bbdbb2d76a80430099c1783c1ace26c.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">评分上方广告图</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in housetops"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="dragend('housetops')"
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        housetops.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'housetops'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'housetops',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'housetops' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*216px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('housetops')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/cd43c2c6075bdbd13ff7d08c429a2d8.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">置业顾问上方广告图</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in housecenters"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="
                                                    dragend('housecenters')
                                                "
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        housecenters.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'housecenters'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'housecenters',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'housecenters' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*216px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('housecenters')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/b143d4a638f0fe87b5d840551479515.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">关联文章上方广告图</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in housebottoms"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="
                                                    dragend('housebottoms')
                                                "
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        housebottoms.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'housebottoms'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'housebottoms',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'housebottoms' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*216px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('housebottoms')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/1ac6c493a0a68f834bb3f08f844f036.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="云招商"
                     name="attract"
                     v-if="isAllCity">
          <div class="item-warp">
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">云招商顶部banner</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in attractbanners"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="
                                                    dragend('attractbanners')
                                                "
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        attractbanners.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'attractbanners'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'attractbanners',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'attractbanners' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*540px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('attractbanners')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/33efbef0933c1a71ba8410b4971dfcc.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">云招商列表穿插</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in attractcells"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="
                                                    dragend('attractcells')
                                                "
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        attractcells.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'attractcells'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'attractcells',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'attractcells' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*216px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('attractcells')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/37c0617573f3ea9d0699683c28464f0.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">云招商详情页</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in attractdetailtops"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="
                                                    dragend('attractdetailtops')
                                                "
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        attractdetailtops.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'attractdetailtops'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'attractdetailtops',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{
                                                type: 'attractdetailtops',
                                            }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*216px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('attractdetailtops')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/c4b5056c3a9fa606a1d47a45d412f24.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="投资军团"
                     name="invest"
                     v-if="isAllCity">
          <div class="item-warp">
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">投资军团顶部广告图</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in investbanners"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="
                                                    dragend('investbanners')
                                                "
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        investbanners.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'investbanners'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'investbanners',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'investbanners' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*540px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('investbanners')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/a6a8f4fe413bbe6bd09c72ca632923f.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="问专家"
                     name="question"
                     v-if="isAllCity">
          <div class="item-warp">
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">问专家广告图</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in questionadvertisings"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="
                                                    dragend(
                                                        'questionadvertisings'
                                                    )
                                                "
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        questionadvertisings.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'questionadvertisings'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'questionadvertisings',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{
                                                type: 'questionadvertisings',
                                            }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*540px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('questionadvertisings')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/65159c34b1bca27eddcf7e7e99e718c.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="导师中心"
                     name="tutor"
                     v-if="isAllCity">
          <div class="item-warp">
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">导师中心广告图</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in tutorcenters"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="
                                                    dragend('tutorcenters')
                                                "
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        tutorcenters.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'tutorcenters'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'tutorcenters',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'tutorcenters' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*216px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('tutorcenters')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/032d19e9f80e2e466597fea0bbd7209.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="视频中心"
                     name="video"
                     v-if="isAllCity">
          <div class="item-warp">
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">视频中心穿插广告</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in videocells"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="dragend('videocells')"
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        videocells.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'videocells'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'videocells',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'videocells' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*216px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('videocells')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/a45a3d598f3f3148a4057cf073cec42.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="产品定制"
                     name="productdz"
                     v-if="isAllCity">
          <div class="item-warp">
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">产品定制顶部广告</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in productcells"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="dragend('productcells')"
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        productcells.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'productcells'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'productcells',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'productcells' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*540px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('productcells')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/788fecc2027b5eb0b86ab126bf3aee3.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="商办资产"
                     name="shangbanad"
                     v-if="isAllCity">
          <div class="item-warp">
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">产品定制顶部广告</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in shangbancells"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="dragend('shangbancells')"
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        shangbancells.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'shangbancells'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'shangbancells',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'shangbancells' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*540px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('shangbancells')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/788fecc2027b5eb0b86ab126bf3aee3.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="办公租赁"
                     name="bangongad"
                     v-if="isAllCity">
          <div class="item-warp">
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">产品定制顶部广告</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in bangongzl"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="dragend('bangongzl')"
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        bangongzl.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'bangongzl'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'bangongzl',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'bangongzl' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*540px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('bangongzl')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/788fecc2027b5eb0b86ab126bf3aee3.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="壹产业"
                     name="yichanye"
                     v-if="isAllCity">
          <div class="item-warp">
            <el-row class="item-cell">
              <el-col class="item-col"
                      :span="18">
                <div class="edit-warp">
                  <p class="text title">壹产业顶部广告</p>
                  <div class="edit-box">
                    <transition-group name="flip-list"
                                      tag="div">
                      <div class="img-box"
                           v-for="(
                                                    item, index
                                                ) in yichanyelist"
                           :key="index"
                           draggable="true"
                           @dragstart="dranstart(item)"
                           @dragend="dragend('yichanyelist')"
                           @dragenter="dragenter(item)">
                        <el-image class="img"
                                  :src="item.path"
                                  fit="contain"
                                  :preview-src-list="
                                                        yichanyelist.previews
                                                    "></el-image>
                        <el-button class="delete-btn"
                                   type="danger"
                                   size="small"
                                   @click.stop="
                                                        deleteimg(
                                                            item,
                                                            index,
                                                            'yichanyelist'
                                                        )
                                                    "
                                   icon="el-icon-delete"
                                   circle></el-button>
                        <div class="url-box">
                          <el-row class="url-cell">
                            <el-select class="custom-input"
                                       v-model="item.url"
                                       placeholder="请选择图片跳转链接"
                                       clearable
                                       filterable
                                       allow-create
                                       size="small">
                              <el-option v-for="(
                                                                    path, ind
                                                                ) in paths"
                                         :key="ind"
                                         :label="
                                                                    path.label
                                                                "
                                         :value="
                                                                    path.url
                                                                ">
                              </el-option>
                            </el-select>
                          </el-row>
                          <el-row class="url-cell">
                            <el-input class="custom-input"
                                      v-model="item.vid"
                                      placeholder="请输入详情页关联id"
                                      size="small"
                                      clearable></el-input>
                          </el-row>
                        </div>
                      </div>
                    </transition-group>
                    <el-upload class="upload-demo"
                               drag
                               action="/api/Upload/uploadFile/"
                               :on-success="
                                                (response) => {
                                                    handleUploadSuccess(
                                                        'yichanyelist',
                                                        response
                                                    );
                                                }
                                            "
                               :before-upload="beforeUpload"
                               :data="{ type: 'yichanyelist' }"
                               multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                      </div>
                    </el-upload>
                  </div>
                </div>
                <div class="remark-warp">
                  <p class="text">
                    备注：请上传尺寸为1080px*540px的图片
                  </p>
                  <el-button type="primary"
                             size="default"
                             @click="confirm('yichanyelist')">保存</el-button>
                </div>
              </el-col>
              <el-col class="item-col"
                      :span="6">
                <p class="text title">位置示例</p>
                <el-image class="example-img"
                          src="https://api.hangehouse.com/static/788fecc2027b5eb0b86ab126bf3aee3.png"
                          fit="fill"></el-image>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>
    </container>
  </div>
</template>

<script>
import container from "../../components/container.vue";
export default {
  components: {
    container,
  },
  data () {
    return {
      activeName: "homepopup",
      homepopup: [],
      homebanners: [],
      areatops: [],
      tutortops: [],
      articlebanners: [],
      articlecells: [],
      articletops: [],
      articlebottoms: [],
      housecells: [],
      housebanners: [],
      housetops: [],
      housecenters: [],
      housebottoms: [],
      attractbanners: [],
      attractcells: [],
      attractdetailtops: [],
      investbanners: [],
      questionadvertisings: [],
      tutorcenters: [],
      videocells: [],
      productcells:[],
      shangbancells:[],
      bangongzl:[],
      yichanyelist:[],
      cityList: [],
      selectedCity: "武汉",
      isAllCity: true,
      paths: [
        {
          label: "投资军团",
          url: "/pages/home/invest2/invest2",
        },
        {
          label: "活动详情",
          url: "/packages/pages/activity/detail/detail?id=",
          id: "",
        },
        {
          label: "问专家首页",
          url: "/packages/pages/question/list/list",
        },
        {
          label: "问专家详情",
          url: "/packages/pages/question/detail/detail?qid=",
          id: "",
        },
        {
          label: "投资资讯首页",
          url: "/pages/home/news/news",
        },
        {
          label: "投资资讯详情页",
          url: "/packages/pages/information/article/article?id=",
          id: "",
        },
        {
          label: "楼盘详情页",
          url: "/packages/pages/house/info/info?house_id=",
          id: "",
        },
        {
          label: "招商项目或房源",
          url: "/packages/pages/attract/detail/detail?id=",
          id: "",
        },
        {
          label: "导师专属页面",
          url: "/pages/home/tutor/tutor?id=",
          id: "",
        },
        {
          label: "置业顾问中心",
          url: "/pages/home/webview/webview?url=https://applet.hangehouse.com/#/consultant/index&title=置业顾问中心",
          id: "",
        },
        {
          label: "经纪人中心",
          url: "/pages/home/webview/webview?url=https://applet.hangehouse.com/#/attract/house/list&title=房源管理",
          id: "",
        },
        {
          label: "导师中心",
          url: "/pages/home/webview/webview?url=https://applet.hangehouse.com/#/tutor/index&title=导师中心",
        },
        {
          label: "我要卖房",
          url: "/packages/pages/sell/house-list/house-list",
        },
        {
          label: "帮我找房",
          url: "/pages/home/looking-for-a-room/looking-for-a-room",
        },
        {
          label: "武汉高品质住宅研究和测评中心-正式成立",
          url: "/pages/home/webview/webview?url=https://applet.hangehouse.com/cpzx/#/apartment&title=武汉高品质住宅研究和测评中心-正式成立",
        },
        {
          label: "法拍房",
          url: "/pages/home/webview/webview?url=https://applet.hangehouse.com/#/foreclosure&title=法拍房",
        },
      ],
      oldNum: 0,
      newNum: 0,
    };
  },
  mounted () {
    let city = this.$store.getters.getuser.city;
    if (city === "全部") {
      this.isAllCity = true;
    } else {
      this.isAllCity = false;
      this.activeName = "home";
      this.selectedCity = city;
    }
    this.getCityList();
    this.changetabs();
  },
  methods: {
    changetabs () {
      var tab = this.activeName;
      switch (tab) {
        case "homepopup":
          this.getimages(tab);
          break;
        case "home":
          this.getimages("");
          this.getimages("areatops");
          this.getimages("tutortops");
          break;
        case "article":
          this.getimages("articlebanners");
          this.getimages("articlecells");
          this.getimages("articletops");
          this.getimages("articlebottoms");
          break;
        case "house":
          this.getimages("housecells");
          this.getimages("housebanners");
          this.getimages("housetops");
          this.getimages("housecenters");
          this.getimages("housebottoms");
          break;
        case "attract":
          this.getimages("attractbanners");
          this.getimages("attractcells");
          this.getimages("attractdetailtops");
          break;
        case "invest":
          this.getimages("investbanners");
          break;
        case "question":
          this.getimages("questionadvertisings");
          break;
        case "tutor":
          this.getimages("tutorcenters");
          break;
        case "video":
          this.getimages("videocells");
          break;
        case "productdz":
          this.getimages("productcells");
          break;
          case "shangbanad":
          this.getimages("shangbancells");
          break;
          case "bangongad":
          this.getimages("bangongzl");
          break;
          case "yichanye":
          this.getimages("yichanyelist");
          break;
      }
    },
    getimages (tab) {
      var params = {
        type: tab,
      };
      if (!tab) {
        let city = this.selectedCity;
        params = {
          type: tab,
          city,
        };
      }
      this.$api.getAppletHomeBanner(params).then((data) => {
        if (data) {
          var imgs = JSON.parse(data.banner);
          var previews = [];
          for (let img of imgs) {
            previews.push(img.path);
          }
          imgs.previews = previews;
          if (tab) {
            this[tab] = imgs;
          } else {
            this.homebanners = imgs;
            console.log(this.homebanners, '000');
          }
        } //62737fe87f440000cc006eab -62737fe87f440000cc006eab
      });
     
    },
    deleteimg (item, index, str) {
      this.$confirm("是否确定删除这张图片？")
        .then((_) => {
          this[str].splice(index, 1);
        })
        .catch((_) => { });
    },
    confirm (type) {
      var params = {};
      if (type) {
        params = {
          type,
          banners: JSON.stringify(this[type]),
        };
      } else {
        params = {
          banners: JSON.stringify(this.homebanners),
          city: this.selectedCity,
        };
      }
      if (!params.banners) {
        this.$alert("缺少图片内容,不能上传");
        return;
      }
      this.$api.setAppletHomeBanner(params).then((data) => {
        this.$message.success(data);
      });
    },
    handleUploadSuccess (item, response) {
      let { data, errCode, msg } = response;
      if (data) {
        this.$message.success(msg);
        var obj = {
          vid: "",
          url: "",
          path: data,
        };
        this[item].push(obj);

        this.$forceUpdate();
      } else {
        this.$message.error(msg);
      }
    },
    beforeUpload (file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      // const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG && !isPNG) {
        this.$message.error("只能上传图片，不能上传其他文件!");
      }
      // if (!isLt2M) {
      //     this.$message.error('上传的图片大小不能超过 1MB!');
      // }

      return isJPG || isPNG;
    },
    dranstart (value) {
      this.oldNum = value;
    },
    dragend: function (types) {
      if (this.oldNum != this.newNum) {
        let oldIndex = this[types].indexOf(this.oldNum);
        let newIndex = this[types].indexOf(this.newNum);
        let newItems = [...this[types]];
        // 删除老的节点
        newItems.splice(oldIndex, 1);
        // 在列表中目标位置增加新的节点
        newItems.splice(newIndex, 0, this.oldNum);
        // this.items一改变，transition-group就起了作用
        this[types] = [...newItems];
      }
    },
    dragenter: function (value) {
      this.newNum = value;
    },
    getCityList () {
      this.$api.getCityList("").then((data) => {
        this.cityList = data;
      });
    },
    handleCity () {
      this.getimages("");
    },
  },
};
</script>

<style lang="scss" scoped>
.item-warp {
  padding: 10px;
  box-sizing: border-box;
  overflow: hidden;
  .item-cell {
    border-bottom: 1px solid #999;
    .item-col {
      border-right: 1px solid #eee;
      .text.title {
        border-bottom: 1px solid #eee;
        padding: 10px;
        background: #f7f7f7;
        font-size: 16px;
      }
      .example-img {
        width: 240px;
        margin-left: 50%;
        transform: translateX(-120px);
        margin-top: 10px;
      }
      .edit-warp {
        .edit-box {
          overflow: hidden;
          padding: 10px;
          box-sizing: border-box;
          .img-box {
            float: left;
            margin-right: 10px;
            margin-bottom: 10px;
            width: 200px;
            height: 240px;
            border: 1px dashed #d9d9d9;
            overflow: hidden;
            padding: 1px;
            box-sizing: border-box;
            position: relative;
            &:hover {
              .cover-view {
                display: block;
              }
            }
            .img {
              height: 167px;
              float: left;
            }
            .delete-btn {
              position: absolute;
              right: 0;
              top: 0;
              z-index: 2;
            }
            .cover-view {
              display: none;
              position: absolute;
              width: 200px;
              height: 168px;
              top: 0;
              left: 0;
              background: rgba($color: #000000, $alpha: 0.4);
              z-index: 1;
              .el-icon-plus {
                line-height: 168px;
                text-align: center;
                width: 200px;
                display: inline-block;
                color: #fff;
                font-size: 20px;
              }
            }
            .url-box {
              border-top: 1px dashed #d9d9d9;
              height: 65px;
              margin-top: 1px;
              float: left;
              .url-cell {
                border-bottom: 1px;
                padding: 1px;
                &:last-child {
                  border-bottom: none;
                }
                .custom-input {
                  // margin-top: 1px;
                  ::v-deep .el-input__inner {
                    border-radius: 0;
                  }
                }
              }
            }
          }
          .upload-demo {
            float: left;

            ::v-deep .el-upload-dragger {
              width: 200px;
              height: 240px;
              border-radius: 0;
            }
          }
        }
      }
      .remark-warp {
        background: #f7f7f7;
        padding: 10px;
        .text {
          color: #666;
          margin-bottom: 10px;
        }
        .selector {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
